import EventResults from './EventResults'

export default EventResults
